import * as yup from 'yup';

const validationFields = {
  password: yup
    .string()
    .required('validations.resetPassword.password.required')
    .min(8, 'validations.resetPassword.password.minLength'),
  passwordConfirmation: yup
    .string()
    .oneOf([yup.ref('password'), null], 'validations.resetPassword.passwordConfirmation.passwordMatch')
    .required('validations.resetPassword.passwordConfirmation.required'),
};

export const validationSchema = yup.object().shape({ ...validationFields });

export const initialValues = {
  password: '',
  passwordConfirmation: '',
};



// WEBPACK FOOTER //
// ./src/forms/resetPasswordForm.js